import { ReactNode } from "react"
import { Flex, Box, Text } from "@shared/primitive-components"
import * as styles from "./formInputContainerStyles"

interface Props {
  label: string
  required?: boolean
  children: ReactNode
  id?: string
  inModal?: boolean
}

export const FormInputContainer: React.FC<Props> = ({
  label,
  required,
  inModal,
  children,
  ...containerProps
}: Props) => (
  <Flex css={styles.root} {...containerProps} alignItems="center">
    <Text tag="label" css={styles.makeLabelStyle(inModal)} title={required ? `Required` : undefined}>
      {label}
      {required && <Box css={styles.marker}>*</Box>}
    </Text>
    <Box css={styles.makeFieldStyle(inModal)}>{children}</Box>
  </Flex>
)

FormInputContainer.defaultProps = {
  required: false,
  id: undefined,
  inModal: false,
}
